import { isProduction } from '@/utils/appHelpers';

if (isProduction()) {
  navigator.serviceWorker?.register(`${process.env.BASE_URL}service-worker.js`);
}
